<div id="doctors-list" class="flex flex-col gap-3">
  <div class="flex flex-row justify-between items-center">
    <a class="cursor-pointer flex flex-row items-center gap-1" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
    <div class="flex flex-row gap-3">
      <button mat-stroked-button color="accent" type="button" (click)="openFullReport()">Full Report & Microbiome</button>
      <button mat-flat-button color="primary" type="button" (click)="saveDraft()">Save as Draft</button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-row gap-3 justify-between w-full">
    @if (patientImages) {
      <app-request-image class="flex-1" [images]="patientImages"></app-request-image>
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (surveyResult && !loadingSurvey) {
      <div class="flex-1 form-data">
        @for (res of surveyResult | keyvalue; track res) {
          <div class="field">
            <label>{{ ('survey.' + $any(res.key)) | translate }}:</label>
            <div class="data">
              <p>{{ res.value | commaSpace }}</p>
            </div>
          </div>
        }

      </div>
    } @else if (loadingSurvey) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else {
      <p>No survey data available</p>
    }
  </div>
  <div class="w-full mt-8">
    <form [formGroup]="reportForm" class="w-full flex flex-col gap-4">
      <div class="flex w-full gap-16 justify-between">
        <div class="flex flex-col gap-6 flex-1">
          <div class="flex flex-row justify-between">
            <div class="flex flex-col">
              <label>
                Acne
              </label>
              <mat-button-toggle-group
                name="acne"
                aria-label="acne"
                formControlName="acne"
                [hideSingleSelectionIndicator]="true"
              >
                <mat-button-toggle value="no">No</mat-button-toggle>
                <mat-button-toggle value="mild">Mild</mat-button-toggle>
                <mat-button-toggle value="moderate">Moderate</mat-button-toggle>
                <mat-button-toggle value="severe">Severe</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <!--            <div class="flex flex-col">-->
            <!--              <label>-->
            <!--                Acne Percentage-->
            <!--              </label>-->
            <!--              <mat-select placeholder="Acne Percentage" formControlName="acne_percentage">-->
            <!--                @for (item of acnePercentage; track item) {-->
            <!--                  <mat-option [value]="item">{{ item }}%</mat-option>-->
            <!--                }-->
            <!--              </mat-select>-->
            <!--            </div>-->
          </div>
          <div class="flex flex-col">
            <label>
              Recommendations for Acne
            </label>
            <textarea formControlName="acne_recommendation"></textarea>
          </div>
          <div class="flex flex-row justify-between gap-3">
            <div class="flex flex-col">
              <label>
                Pigmentation
              </label>
              <mat-button-toggle-group
                name="pigmentation"
                aria-label="pigmentation"
                formControlName="pigmentation"
                [hideSingleSelectionIndicator]="true"
              >
                <mat-button-toggle value="no">No</mat-button-toggle>
                <mat-button-toggle value="mild">Mild</mat-button-toggle>
                <mat-button-toggle value="moderate">Moderate</mat-button-toggle>
                <mat-button-toggle value="severe">Severe</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div class="flex flex-col">
              <label>
                SPF recommendation
              </label>
              <mat-select placeholder="SPF recommendation" formControlName="spf">
                @for (item of spfOptions; track item) {
                  <mat-option [value]="item">{{ item }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div formGroupName="pigmentation_details">
            <div class="flex w-full justify-between gap-3 mt-3">
              <div class="w-full">
                <label>
                  Eye area
                </label>
                <mat-select placeholder="Select..." formControlName="eye_area">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="w-full">
                <label>
                  Overall face
                </label>
                <mat-select placeholder="Select..." formControlName="overall_face">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="flex w-full justify-between gap-3 mt-5">
              <div class="w-full">
                <label>
                  Malar area
                </label>
                <mat-select placeholder="Select..." formControlName="malar_area">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="w-full">

              </div>
            </div>
            <div class="flex flex-col mt-5">
              <label>
                Recommendations for Pigmentation
              </label>
              <textarea formControlName="pigmentation_recommendations"></textarea>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-6 flex-1">
          <div class="flex flex-row justify-between">
            <div class="flex flex-col">
              <label>
                Skin type
              </label>
              <mat-button-toggle-group
                name="skin_type"
                aria-label="skin_type"
                formControlName="skin_type"
                [hideSingleSelectionIndicator]="true"
              >
                <mat-button-toggle value="normal">Normal</mat-button-toggle>
                <mat-button-toggle value="dry">Dry</mat-button-toggle>
                <mat-button-toggle value="oily">oily</mat-button-toggle>
                <mat-button-toggle value="combination">Combination</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div></div>
          </div>
          <div class="flex flex-col">
            <label>
              Recommendations for Skin
            </label>
            <textarea formControlName="skin_recommendation"></textarea>
          </div>
          <div class="flex flex-row justify-between">
            <div class="flex flex-col">
              <label>
                Wrinkles
              </label>
              <mat-button-toggle-group
                name="wrinkles"
                aria-label="wrinkles"
                formControlName="wrinkles"
                [hideSingleSelectionIndicator]="true"
              >
                <mat-button-toggle value="no">No</mat-button-toggle>
                <mat-button-toggle value="mild">Mild</mat-button-toggle>
                <mat-button-toggle value="moderate">Moderate</mat-button-toggle>
                <mat-button-toggle value="severe">Severe</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>

          <div formGroupName="wrinkles_details">
            <div class="flex w-full justify-between gap-3 mt-5">
              <div class="w-full">
                <label>
                  Eye area
                </label>
                <mat-select placeholder="Select..." formControlName="eye_area">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="w-full">
                <label>
                  Forehead
                </label>
                <mat-select placeholder="Select..." formControlName="forehead_area">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="flex w-full justify-between gap-3 mt-5">
              <div class="w-full">
                <label>
                  Nose area
                </label>
                <mat-select placeholder="Select..." formControlName="nose_area">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="w-full">
                <label>
                  Lips area
                </label>
                <mat-select placeholder="Select..." formControlName="lips_area">
                  @for (item of levelOptions; track item) {
                    <mat-option [value]="item">{{ item }}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="flex flex-col mt-5">
              <label>
                Wrinkles recommendations
              </label>
              <textarea formControlName="wrinkles_recommendations"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col mt-5">
        <label>
          Additional Notes
        </label>
        <textarea formControlName="extra_notes"></textarea>
      </div>
    </form>
  </div>
</div>
<!-- src/app/pages/reports-requests/request-detail/request-detail.component.html -->
